<div class="pm">
  <button
    type="button"
    class="pm-trigger"
    pRipple
    (click)="toggle()"
    [attr.aria-expanded]="open()"
    [attr.aria-label]="'profileMenu.open' | translate">
    <img *ngIf="photoUrl() as photo; else initialsTpl" [src]="photo" alt="" class="pm-avatar-img" />
    <ng-template #initialsTpl><span class="pm-avatar">{{ initials() }}</span></ng-template>
  </button>

  <div class="pm-panel" *ngIf="open()" role="menu">
    <!-- Who I am, and on which email. -->
    <div class="pm-head">
      <img *ngIf="photoUrl() as photo; else headInitials" [src]="photo" alt="" class="pm-avatar-img pm-avatar-lg" />
      <ng-template #headInitials><span class="pm-avatar pm-avatar-lg">{{ initials() }}</span></ng-template>
      <div class="pm-id">
        <span class="pm-name">{{ displayName() || ('profileMenu.admin' | translate) }}</span>
        <span class="pm-email">{{ email() || ('profileMenu.noEmail' | translate) }}</span>
      </div>
    </div>

    <div class="pm-divider"></div>

    <!-- Change password -->
    <ng-container *ngIf="canChangePassword(); else providerNote">
      <button *ngIf="!showPasswordForm()" type="button" class="pm-action" (click)="openPasswordForm()">
        <i class="pi pi-key"></i> {{ 'profileMenu.changePassword' | translate }}
      </button>

      <form *ngIf="showPasswordForm()" class="pm-form" (ngSubmit)="submitPassword()">
        <label class="pm-label">
          {{ 'profileMenu.currentPassword' | translate }}
          <input type="password" class="pm-input" autocomplete="current-password"
            [ngModel]="currentPassword()" (ngModelChange)="currentPassword.set($event)" name="current" />
        </label>
        <label class="pm-label">
          {{ 'profileMenu.newPassword' | translate }}
          <input type="password" class="pm-input" autocomplete="new-password"
            [ngModel]="newPassword()" (ngModelChange)="newPassword.set($event)" name="new" />
        </label>
        <label class="pm-label">
          {{ 'profileMenu.confirmPassword' | translate }}
          <input type="password" class="pm-input" autocomplete="new-password"
            [ngModel]="confirmPassword()" (ngModelChange)="confirmPassword.set($event)" name="confirm" />
        </label>

        <p class="pm-hint" *ngIf="newPassword().length > 0 && newPassword().length < 6">
          {{ 'profileMenu.pwdTooShort' | translate }}
        </p>
        <p class="pm-hint" *ngIf="confirmPassword().length > 0 && newPassword() !== confirmPassword()">
          {{ 'profileMenu.pwdMismatch' | translate }}
        </p>

        <div class="pm-form-actions">
          <button type="button" class="pm-btn pm-btn-ghost" (click)="openPasswordForm(); showPasswordForm.set(false)">
            {{ 'profileMenu.cancel' | translate }}
          </button>
          <button type="submit" class="pm-btn pm-btn-primary" [disabled]="!passwordValid || saving()">
            {{ (saving() ? 'profileMenu.saving' : 'profileMenu.save') | translate }}
          </button>
        </div>
      </form>
    </ng-container>

    <ng-template #providerNote>
      <p class="pm-note"><i class="pi pi-info-circle"></i> {{ 'profileMenu.providerNote' | translate }}</p>
    </ng-template>

    <p class="pm-feedback" *ngIf="feedback() as fb" [class.is-error]="fb.kind === 'error'" [class.is-success]="fb.kind === 'success'">
      {{ fb.messageKey | translate }}
    </p>

    <div class="pm-divider"></div>

    <button type="button" class="pm-action pm-action-danger" (click)="logout()">
      <i class="pi pi-sign-out"></i> {{ 'profileMenu.logout' | translate }}
    </button>
  </div>
</div>
